import { render, staticRenderFns } from "./BudgetSaldoWidget.vue?vue&type=template&id=4aaf2cb9&scoped=true&"
import script from "./BudgetSaldoWidget.vue?vue&type=script&lang=js&"
export * from "./BudgetSaldoWidget.vue?vue&type=script&lang=js&"
import style0 from "./BudgetSaldoWidget.vue?vue&type=style&index=0&id=4aaf2cb9&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../../frontend/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4aaf2cb9",
  null
  
)

export default component.exports